<div class="comments" [@detailExpand]="isExpanded ? 'expanded' : 'collapsed'">
    <div class="comment-viewer-container">
        @for (comment of sortedComments; track comment.id) {
            <div class="comment-viewer-content">
                <div class="comment-container">
                    <div class="comment-header">
                        <p class="comment-user">Commentaire de {{ comment.user }}</p>
                        @if (comment.state === CommentState.Updated) {
                            <p class="comment-state mode-history">(modifié)</p>
                        } @else if (comment.state === CommentState.Deleted) {
                            <p class="comment-state mode-history">(Supprimé)</p>
                        } @else if (comment.state === CommentState.Created && comment.iteration > 1) {
                            <p class="comment-state">(Modifié)</p>
                        }
                        <p class="comment-date">Le {{ comment.date | AvmDateAndTime }}</p>
                    </div>
                    <div class="comment-content">
                        @if (comment.state !== CommentState.Deleted) {
                            <div class="comment-text" [ngClass]="{ 'comment-updated': comment.state === CommentState.Updated }" [innerHtml]="comment.safeText"></div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
    <ngx-spinner [name]="spinnerName" [fullScreen]="false" type="timer" size="default"></ngx-spinner>
</div>
